import React, { useState, useEffect } from "react";
import "./VTInsulation.css";

const VTInsulation = ({ goBack, goToNext, formData, updateFormData }) => {
  const STORAGE_KEY = 'vt_insulation_data';

  const generateReferences = (winding) => {
    const base = ["Primary - Earth", "Primary - Core 1"];
    const coreCount = winding.startsWith("da") ? 5 : parseInt(winding[0]);

    for (let i = 2; i <= coreCount; i++) {
      base.push(`Primary - Core ${i}`);
    }

    for (let i = 1; i <= coreCount; i++) {
      for (let j = i + 1; j <= coreCount; j++) {
        base.push(`Core ${i} - Core ${j}`);
      }
    }

    for (let i = 1; i <= coreCount; i++) {
      base.push(`Core ${i} - Earth`);
    }

    return base;
  };

  const references = generateReferences(formData.winding);


  const loadFromStorage = () => {
    try {
      const storedData = localStorage.getItem(STORAGE_KEY);
      if (storedData) {
        const parsedData = JSON.parse(storedData);
       
        if (parsedData.length === references.length) {
          return parsedData;
        }
      }
    } catch (error) {
      console.error('Error loading from localStorage:', error);
    }
    return null;
  };

  const [measurements, setMeasurements] = useState(
    formData.insulationData.length > 0
      ? formData.insulationData
      : loadFromStorage() || references.map((ref, index) => ({
          reference: ref, 
          appliedVoltage: "",
          rPh: "",
          rPhUnit: "",
          yPh: "",
          yPhUnit: "",
          bPh: "",
          bPhUnit: "",
        }))
  );

useEffect(() => {
  const newReferences = generateReferences(formData.winding);
  
  if (!formData.winding) {
    return;
  }

  
  if (measurements.length === newReferences.length) {
    
    const referencesMatch = measurements.every((m, idx) => m.reference === newReferences[idx]);
    if (referencesMatch) {
      return; 
    }
  }
  
  const storedData = loadFromStorage();
  const existingData = storedData || formData.insulationData || [];
  
  const existingDataMap = new Map();
  existingData.forEach(item => {
    if (item && item.reference) {
      existingDataMap.set(item.reference, item);
    }
  });
  
  const newMeasurements = newReferences.map((ref) => {
    if (existingDataMap.has(ref)) {
      return existingDataMap.get(ref);
    }
    
    return {
      reference: ref,
      appliedVoltage: "",
      rPh: "",
      rPhUnit: "",
      yPh: "",
      yPhUnit: "",
      bPh: "",
      bPhUnit: "",
    };
  });
  
  setMeasurements(newMeasurements);
  
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newMeasurements));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
}, [formData.winding]); 



  const validateInput = (value) => {
    return value.replace(/[^0-9.<> ]/g, "");
  };

  const handleChange = (index, field, value) => {
    const updated = [...measurements];
    if (field === "rPh" || field === "yPh" || field === "bPh") {
      updated[index][field] = validateInput(value);
    } else {
      updated[index][field] = value;
    }
    setMeasurements(updated);
  
  };

const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};

  const handleSubmit = (e) => {
    e.preventDefault();
 
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(measurements));
    } catch (error) {
      console.error('Error saving to localStorage on submit:', error);
    }
    updateFormData(measurements);
    goToNext();
  };

  const getVoltageOptions = (ref) => {
    return ref.includes("Primary")
      ? ["250 V", "500 V", "1000 V", "2500 V", "5000 V"]
      : ["250 V", "500 V"];
  };

  const unitOptions = ["Ω", "KΩ", "MΩ", "TΩ", "GΩ"];

  return (
    <form onSubmit={handleSubmit} className="vt-1001">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 className="vt-1002">Insulation Resistance Measurement</h3>

        <div style={{ display: 'flex', gap: '10px' }}>
          <span 
            style={{ 
              display: 'flex',
              justifyContent: 'flex-end',
              fontSize: '20px', 
              fontWeight: 'bold', 
              color: '#333', 
              cursor: 'pointer',
              marginLeft: '20px',
              marginBottom: '50px'
            }}
            onClick={redirectToHome}
          >
            X
          </span>
        </div>
      </div>

      <div className="vt-1003">
        <div className="vt-1004 vt-1005">
          <div>Reference</div>
          <div>Applied Voltage</div>
          <div className="vt-1006">Measured Value</div>
        </div>

        <div className="vt-1004 vt-1007">
          <div className="vt-1008" />
          <div className="vt-1008" />
          <div>R - ph</div>
          <div>Y - ph</div>
          <div>B - ph</div>
        </div>

        {measurements.map((measurement, index) => (
          <div className="vt-1004" key={index}>
            <div className="vt-1009">{measurement.reference}</div>
            <div>
              <select
                value={measurement.appliedVoltage}
                onChange={(e) =>
                  handleChange(index, "appliedVoltage", e.target.value)
                }
              >
                <option value="">Select Voltage</option>
                {getVoltageOptions(measurement.reference).map((v) => (
                  <option key={v} value={v}>
                    {v}
                  </option>
                ))}
              </select>
            </div>

            <div className="vt-measurement-combo">
              <input
                type="text"
                value={measurement.rPh}
                maxLength={10}
                onChange={(e) => handleChange(index, "rPh", e.target.value)}
                placeholder="Enter R-ph"
                inputMode="decimal"
              />
              <select
                value={measurement.rPhUnit}
                onChange={(e) => handleChange(index, "rPhUnit", e.target.value)}
              >
                <option value="">Units</option>
                {unitOptions.map((u) => (
                  <option key={u} value={u}>
                    {u}
                  </option>
                ))}
              </select>
            </div>

            <div className="vt-measurement-combo">
              <input
                type="text"
                value={measurement.yPh}
                maxLength={10}
                onChange={(e) => handleChange(index, "yPh", e.target.value)}
                placeholder="Enter Y-ph"
                inputMode="decimal"
              />
              <select
                value={measurement.yPhUnit}
                onChange={(e) => handleChange(index, "yPhUnit", e.target.value)}
              >
                <option value="">Units</option>
                {unitOptions.map((u) => (
                  <option key={u} value={u}>
                    {u}
                  </option>
                ))}
              </select>
            </div>

            <div className="vt-measurement-combo">
              <input
                type="text"
                value={measurement.bPh}
                maxLength={10}
                onChange={(e) => handleChange(index, "bPh", e.target.value)}
                placeholder="Enter B-ph"
                inputMode="decimal"
              />
              <select
                value={measurement.bPhUnit}
                onChange={(e) => handleChange(index, "bPhUnit", e.target.value)}
              >
                <option value="">Units</option>
                {unitOptions.map((u) => (
                  <option key={u} value={u}>
                    {u}
                  </option>
                ))}
              </select>
            </div>
          </div>
        ))}
      </div>

      <div className="vt-1010">
        <button type="button" onClick={goBack}>
          Back
        </button>
        <button type="submit">Next</button>
      </div>
    </form>
  );
};

export default VTInsulation;

